export default "__VITE_ASSET__836c8d64__"